module.exports = __webpack_public_path__ + "static/media/lock.7b135206.svg";